<div class="alert alert-dismissible"
     [ngClass]="{'alert-error': type === 'Error', 'alert-success': type === 'Success', 'alert-info': type === 'Alert'}"
     *ngIf="text" role="alert" [@state]="text && text.length">
  <i class="fa fa-check-circle" *ngIf="type === 'Success'"></i>
  <i class="fa fa-times-circle" *ngIf="type === 'Error'"></i>
  <i class="fa fa-info-circle" *ngIf="type === 'Alert' || type === 'NonDismissibleAlert'"></i>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"
          *ngIf="type !== 'NonDismissibleAlert'"
          (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
  <span class="message">{{text}}</span>
</div>